export default "data:image/gif;base64,Cg=="